<template>
  <Box class="monetization-card__container">
    <Box
      class="monetization-card__content"
      p="6"
      is-flex
      flex-direction="column"
      justify-content="space-between"
      gap="6"
    >
      <Box is-flex flex-direction="column" gap="4">
        <Heading size="h3">{{ title }}</Heading>
        <CustomText size="large">{{ description }}</CustomText>
      </Box>
      <Box is-flex flex-direction="column" align-items="center">
        <img class="monetization-card__img" :src="src" :srcset="srcset">
      </Box>
    </Box>
  </Box>
</template>

<script>
import Box from '@/components/common/Box/Box'
import CustomText from '@/components/common/CustomText/CustomText'
import Heading from '@/components/common/Heading/Heading'

export default {
  components: {
    Box,
    Heading,
    CustomText
  },

  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    src: {
      type: String,
      required: true
    },
    srcset: {
      type: String,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.monetization-card {
  &__container {
    background-color: #291840;
    border: 1px solid #3e2f53;
    border-radius: 16px;
  }

  &__content {
    height: 100%;
  }
}
</style>
